import React, { useEffect, useState } from "react";
import { BiCopy, BiData, BiLineChart, BiListUl, BiPieChart, BiTransfer } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import PerformanceMain from "./Performance/PerformanceMain";
import PlayboxLogsMain from "./Logs/PlayboxLogsMain";
import PlayboxPricingMain from "./Pricing/PlayboxPrixingMain";
// import Scaling from "./Scaling/Scaling";

const OpenPlaybox = () => {
    const user_id = sessionStorage.getItem("user_id");
    const { project_id, playbox_id, link_page } = useParams()
    const navigate = useNavigate()
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false);
    const [copied, setCopied] = useState(false)
    const [playboxName, setplayboxName] = useState(null)
    const [metrics, setMetrics] = useState({})
    const [costMetrics, setCostMetrics] = useState(null)
    const [openInfo, setOpenInfo] = useState(false)
    const [podInfo, setPodInfo] = useState({})

    const changePage = (page) => {
        navigate(`/project_panel/${project_id}/playbox/${playbox_id}/${page}`)
    }

    const goBack = () => {
        navigate(`/project_panel/${project_id}/playbox`)
    }

    const fetchRecords = async () => {
        try {
            const response = await fetch("https://backend.erioon.com/get_specific_playbox", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id, playbox_id }),
            });

            if (response.ok) {
                const result = await response.json();
                const data = result.playbox || {};
                const pod_info = result.pod_info || {};
                const costs = result.current_cost || 0;
                setRecords(data);
                setPodInfo(pod_info)
                setMetrics(metrics)
                setplayboxName(data.playbox_name)
                setError(false);
                setLoading(false);
                return data.status;
            } else {
                setError(true);
                setLoading(false);
            }
        } catch (err) {
            setError(true);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (user_id) {
            fetchRecords()
        } else {
            setError(true);
            setLoading(false);
        }
    }, []);



    const handleCopyClick = () => {
        navigator.clipboard.writeText(playbox_id);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div>
            <div className="new_section_main_view">
                <p className="new_section_main_view_title">
                    <i className="fa-solid fa-chevron-left" onClick={goBack}></i> <span className={`${playboxName ? "new_section_main_view_title_span" : "new_section_main_view_title_span_loading"}`}>{playboxName}</span>
                    <span className={`${playbox_id ? "new_section_main_view_title_db_id" : "new_section_main_view_title_db_id_loading"}`}>
                        {playbox_id}
                        {playbox_id && (
                            <i onClick={handleCopyClick}>
                                {copied ? (
                                    <i className="fa-solid fa-check"></i>
                                ) : (
                                    <BiCopy />
                                )}
                            </i>
                        )}
                    </span>
                </p>
                <p className="new_section_main_view_subtitle">
                    All the resources you need in a single page.
                </p>
                {!loading && (
                    <></>
                )}

                <div className="open_db_main_view">
                    <div className="open_db_main_navbar">
                        <div className="open_db_main_navbar_cont">
                            {/* <button className={`open_db_main_btn ${link_page === "performance" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("performance")}><IoMdTrendingUp /> Performance</button> */}
                            <button className={`open_db_main_btn ${link_page === "logs" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("logs")}><BiListUl /> Playbox event logs</button>
                            {/* <button className={`open_db_main_btn ${link_page === "playbox-pricing" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("playbox-pricing")}><TbZoomMoney /> Usage</button> */}
                        </div>
                        <div className="open_db_main_navbar_cont">
                            {/* <button className="open_db_main_btn" onClick={() => setOpenInfo(true)}><i className="fa-solid fa-info"></i> Info</button> */}
                        </div>
                    </div>
                    {loading ? (
                        <div className="loading_playbox_cont">

                        </div>
                    ) : (
                        <>
                            {link_page === "performance" ? (
                                <PerformanceMain/>
                            ):link_page === "logs" ?(
                                <PlayboxLogsMain podInfo={podInfo}/>
                            ):link_page === "playbox-pricing" ?(
                                <PlayboxPricingMain podInfo={podInfo}/>
                            ):(
                                <></>
                            )}
                        </>
                    )}

                </div>
            </div>
{/* 
            <InfoModal
                show={openInfo}
                handleClose={() => setOpenInfo(false)}
                records={records}
            /> */}
        </div>
    )
}

export default OpenPlaybox